var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgClock = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#FFF",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0C11.6452 0 15 3.35441 15 7.5C15 11.6452 11.6456 15 7.5 15C3.35473 15 0 11.6456 0 7.5C0 3.35473 3.35441 0 7.5 0ZM7.13048 7.81078L9.17482 10.2413C9.34648 10.4454 9.65111 10.4717 9.85512 10.3001C10.0592 10.1284 10.0855 9.82383 9.91383 9.61976L7.98282 7.32393V1.86782C7.98282 1.60117 7.76665 1.385 7.5 1.385C7.23335 1.385 7.01718 1.60117 7.01718 1.86782V7.5C7.01718 7.61369 7.05731 7.72377 7.13048 7.81078Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgClock);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/clock.b75a2a0c.svg";